import React, { useState, useEffect } from 'react';
import { FileText } from 'lucide-react';
import { supabase } from '../../lib/supabase';

interface DocumentViewerProps {
  documento: {
    id: string;
    tipo: string;
    storage_path: string | null;
  };
}

export const DocumentViewer = ({ documento }: DocumentViewerProps) => {
  const [signedUrl, setSignedUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getSignedUrl = async () => {
      if (!documento.storage_path) return;

      try {
        const { data: { publicUrl } } = supabase.storage
          .from('documentos')
          .getPublicUrl(documento.storage_path);

        if (publicUrl) {
          setSignedUrl(publicUrl);
        }
      } catch (error) {
        console.error('Error getting signed URL:', error);
      } finally {
        setIsLoading(false);
      }
    };

    getSignedUrl();
  }, [documento]);

  if (isLoading) {
    return (
      <div className="w-full h-[600px] flex items-center justify-center bg-gray-100 rounded-lg">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#004A98]"></div>
      </div>
    );
  }

  if (!signedUrl) {
    return (
      <div className="w-full h-[600px] flex flex-col items-center justify-center bg-gray-100 rounded-lg">
        <FileText className="w-12 h-12 text-gray-400 mb-4" />
        <p className="text-gray-600">No se encontró el documento</p>
      </div>
    );
  }

  return (
    <div className="w-full h-[600px] relative bg-gray-100 rounded-lg overflow-hidden">
      <iframe
        src={`https://docs.google.com/viewer?url=${encodeURIComponent(signedUrl)}&embedded=true`}
        className="w-full h-full"
        style={{ border: 'none' }}
        title={documento.tipo}
      />
    </div>
  );
};